import * as THREE from 'three';

type listType = {data: number, index: N};
type N = number | number[];
type gridNumber = {x: number, y: number}

export class Point {
    
    constructor() {

    }
    
    // grid indexから壁indexを取得
    static gridNumberToIndex(num: number, row: number): gridNumber {
        return {x:num % row, y:Math.floor(num / row) };
    }
    
    // 壁indexからgrid indexを取得
    static indexFromGridNumber(x: number, y: number, row: number): number {
        return x + y * row;
    }
    
    // 壁の片側の頂点を探す
    static nextPoint = (point: number) => (point % 2 == 0) ? point + 1 : point - 1;
    
    // 近傍点の数を返す
    static numNearPoints(p: THREE.Vector3, points: THREE.Vector3[]): number {
        const e = 0.001;
        let sum = 0;
        points.forEach((point: THREE.Vector3) => {
            if (p.distanceTo(point) <= e) sum += 1;
        });

        return sum;
    }

    static nearPoint(p1: THREE.Vector3, points: THREE.Vector3[]): boolean {
        const e = 0.001;
        for (let i = 0; i < points.length; i++) {
            if ( p1.distanceTo(points[i]) <= e) return true;
        }

        return false;
    }
    
    // 点の内外判定
	static containsPoint( box: THREE.Box3, point: THREE.Vector3 ): boolean {
        const e = 0.001;
        const minX = box.min.x + e;
        const minZ = box.min.z + e;
        const maxX = box.max.x - e;
        const maxZ = box.max.z - e;
        return (minX <= point.x) && (minZ <= point.z) && (point.x <= maxX) && (point.z <= maxZ) ? false : true;
	}

}